import { render, staticRenderFns } from "./video-dialog.vue?vue&type=template&id=13969d67"
import script from "./video-dialog.vue?vue&type=script&lang=js"
export * from "./video-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports